import React from 'react'
import moment from 'moment'
import { orderString, orderDate, getKeyFromStatus } from './functions'

export default [
  {
    title: 'Nome',
    dataIndex: 'name',
    key: 'name',
    sorter: (a, b) => orderString(a.name, b.name),
    render: text => <span className="cell name"> {text} </span>
  }, {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    sorter: (a, b) => orderString(a.email, b.email),
    render: text => <span className="cell email"> {text} </span>

  }, {
    title: 'Coachees',
    dataIndex: 'total_coachees',
    key: 'total_coachees',
    sorter: (a, b) => (a.total_coachees - b.total_coachees),
    render: text => <span className="cell total_coachees"> {text} </span>

  }, {
    title: 'Site',
    dataIndex: 'site',
    key: 'site',
    sorter: (a, b) => orderString(a.site, b.site),
    render: site => <a href={site} target="_blank" className="cell site">{site ? "Publicado" : ""}</a>
  }, {
    title: 'Cupom',
    dataIndex: 'coupon',
    key: 'coupon',
    sorter: (a, b) => orderString(a.coupon, b.coupon),
    render: text => <span className="cell coupon"> {text} </span>

  }, {
    title: 'Último acesso',
    dataIndex: 'last_login',
    key: 'last_login',
    sorter: (a, b) => new Date(a.last_login || 0) - new Date(b.last_login || 0),
    render: date => <span className="cell datetime"> { date ? moment(date).format("DD/MM/YYYY HH:mm") : '' }</span>

  }, {
    title: 'Sessões realizadas',
    dataIndex: 'sessions',
    key: 'sessions',
    sorter: (a, b) => a.sessions - b.sessions,
    render: text => <span className="cell sessions"> {text} </span>

  }, {
    title: 'Ciclos finalizados',
    dataIndex: 'complete_cycles',
    key: 'complete_cycles',
    sorter: (a, b) => a.complete_cycles - b.complete_cycles,
    render: text => <span className="cell complete_cycles"> {text} </span>

  }, {
    title: 'Horas coaching',
    dataIndex: 'total_coaching_hours',
    key: 'total_coaching_hours',
    sorter: (a, b) => a.total_coaching_hours - b.total_coaching_hours,
    render: text => <span className="cell total_coaching_hours"> {text} </span>

  }, {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: text => <span className={`cell status status_${getKeyFromStatus(text)}`}>{text}</span>,
    sorter: (a, b) => orderString(a.status, b.status),
  }, {
    title: '',
    dataIndex: 'index',
    key: 'index',
    render: ({ x }) => 
    <button className={`cell btn-view`} onClick={()=>x()}>
      <span> Visualizar </span>
    </button>
  }
];



// WEBPACK FOOTER //
// ./src/utils/table-coaches-columns.js